import { Injectable } from '@angular/core';

// This service will filter the vendors listed
// on Expense Detail, when navigating to
// Expense Detail from Period Close Checklist
// (using the Review Vendor Estimates dropdown)

@Injectable({
  providedIn: 'root',
})
export class QuarterCloseChecklistVendorService {
  filterByVendorId = '';
}
